import { LoadingButton } from "@mui/lab";
import { ConfirmModal } from "features/common/components/ConfirmModal";
import { StatisticsMessage } from "./StatisticsMessage";
import { useStatisticsModal } from "./useStatisticsModal";
import { toIsoString } from "features/common/lib/date";

export interface StatisticsModalProps {
  title: string;
  open: boolean;
  onClose: () => void;
  type: "INTERNAL" | "EXTERNAL";
}

export const StatisticsModal = ({
  title,
  open,
  onClose,
  type,
}: StatisticsModalProps) => {
  const {
    handleClose,
    handleStartRec,
    handleStartStat,
    isExecutingRec,
    executeStatError,
    isExecutingStat,
    reconciliationIsAllowed,
    statisticsIsAllowed,
    reconciliationError,
    severityMessage,
  } = useStatisticsModal({
    statisticsReportType: {
      type: "STATISTICS",
      // TODO: verify in WbhReportRequest actionType why EXTERNAL/INTERNAL and not STATISTICS/RECONCILIATION
      actionType: type,
      timestamp: toIsoString(new Date()),
    },
    reconciliationReportType: {
      type: "RECONCILIATION",
      actionType: type,
      timestamp: toIsoString(new Date()),
    },
    onClose,
  });

  return (
    <ConfirmModal
      title={title}
      open={open}
      onClose={handleClose}
      disableBackdropClick
      isLoading={isExecutingStat}
      error={reconciliationError || executeStatError}
      onConfirm={handleStartStat}
      disableConfirmButton={!statisticsIsAllowed || isExecutingRec}
      confirmButtonMessage="Yes"
      severityMessage={severityMessage}
      secondaryAction={
        <LoadingButton
          onClick={handleStartRec}
          variant="outlined"
          loading={isExecutingRec}
          disabled={!reconciliationIsAllowed || isExecutingStat}
          sx={{ ml: "10px" }}
          children="No"
        />
      }
      children={<StatisticsMessage />}
    />
  );
};
